if (!customElements.get('custom-swatches')) {
  class CustomSwatches extends HTMLElement {
    constructor() {
      super();
      this.isInitializing = false;
    }

    initialize() {
      this.isInitializing = true;
      this.swatches = this.querySelectorAll('.bundle-swatch');
      this.decrementBtns = this.querySelectorAll('.bundle-number-input-decrement');
      this.incrementBtns = this.querySelectorAll('.bundle-number-input-increment');
      this.atcBtn = this.querySelector('.custom-swatches-btn');
      this.inputs = this.querySelectorAll('input');

      this.customSwatchesLabel = this.querySelector('.custom-swatches-label');
      this.container = this.closest('.product-options-form-container');
      this.atcBtn = document.querySelector('.custom-swatches-btn-mobile');
      this.checkbox = document.querySelector('.ProductForm-purchase-options-checkbox');

      this.totalSelected = 0;
      this.colorsSelected = [];

      this.checkboxInput = this.checkbox.querySelector('input');

      // Store bound function references for proper cleanup
      this.boundDecrement = this.decrement.bind(this);
      this.boundIncrement = this.increment.bind(this);
      this.boundToggleSelected = this.toggleSelected.bind(this);
      this.boundToggleCheckbox = this.toggleCheckbox.bind(this);
      this.boundAddToCart = this.addToCart.bind(this);

      if (this.dataset.fetchRendered === 'true') {
        this.dataset.collapsed = 'false';
        this.style.transition = 'none';

        requestAnimationFrame(() => {
          this.style.height = `${this.scrollHeight}px`;
          this.style.height = 'auto';

          requestAnimationFrame(() => {
            this.style.transition = 'all 300ms ease-out';
          });
        });

        const checkedCheckbox = this.checkbox.querySelector('.custom-checkbox-check');
        if (checkedCheckbox) {
          this.atcBtn.style.display = 'block';
        }
      }

      window.dataLayer = window.dataLayer || [];
      this.decrementBtns.forEach((btn) => {
        btn.addEventListener('click', this.boundDecrement);
      });
      this.incrementBtns.forEach((btn) => {
        btn.addEventListener('click', this.boundIncrement);
      });
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', this.boundToggleSelected);
      });

      this.checkbox.addEventListener('click', this.boundToggleCheckbox);
      if (this.checkbox.classList.contains('background')) {
        this.style.display = 'flex';
      } else {
        this.style.display = 'none';
      }

      this.allOOS = Array.from(this.swatches).every((swatch) => swatch.classList.contains('bundle-swatch-oos'));

      if (this.allOOS) {
        this.atcBtn.style.display = 'none';
        this.customSwatchesLabel.style.display = 'none';
      }

      this.atcBtn.addEventListener('click', this.boundAddToCart);

      const checkbox = this.checkbox.querySelector('.custom-purchase-option-checkbox');

      if (checkbox.classList.contains('custom-checkbox-check')) {
        if (typeof setSizes !== 'undefined') {
          const sizes = document.querySelectorAll('variant-selects label');
          sizes.forEach((size) => {
            if (setSizes.includes(size.innerText)) {
              const container = size.closest('label');
              if (!container.classList.contains('bundle-size-available')) {
                container.classList.add('bundle-size-available');
              }
            }
          });
        }

        if (!this.allOOS) {
          const bisContainer = document.querySelector('.klaviyo-bis-container');
          if (bisContainer) {
            bisContainer.style.display = 'none';
          }
        } else {
          const bisContainer = document.querySelector('.klaviyo-bis-container');
          if (bisContainer) {
            bisContainer.style.display = 'block';
          }
        }
      }

      this.isInitializing = false;
    }

    clear() {
      if (this.decrementBtns && this.boundDecrement) {
        this.decrementBtns.forEach((btn) => {
          btn.removeEventListener('click', this.boundDecrement);
        });
      }

      if (this.incrementBtns && this.boundIncrement) {
        this.incrementBtns.forEach((btn) => {
          btn.removeEventListener('click', this.boundIncrement);
        });
      }

      if (this.swatches && this.boundToggleSelected) {
        this.swatches.forEach((swatch) => {
          swatch.removeEventListener('click', this.boundToggleSelected);
        });
      }

      if (this.checkbox && this.boundToggleCheckbox) {
        this.checkbox.removeEventListener('click', this.boundToggleCheckbox);
      }

      if (this.atcBtn && this.boundAddToCart) {
        this.atcBtn.removeEventListener('click', this.boundAddToCart);
      }

      this.totalSelected = 0;
      this.colorsSelected = [];

      if (this.inputs) {
        this.inputs.forEach((input) => {
          input.value = 0;
        });
      }

      const selectedQuantities = this.querySelectorAll('.bundle-selected-quantity');
      selectedQuantities.forEach((qty) => {
        qty.textContent = '';
        qty.classList.remove('has-quantity');
      });

      if (this.swatches) {
        this.swatches.forEach((swatch) => {
          swatch.classList.remove('selected');
        });
      }

      if (this.customSwatchesLabel) {
        this.customSwatchesLabel.innerHTML = 'Color';
      }

      if (this.atcBtn) {
        this.atcBtn.disabled = true;
        this.atcBtn.innerHTML = `<span class="btn-text">Choose 4 or more</span>`;
        this.atcBtn.classList.remove('loading');
        this.atcBtn.removeAttribute('aria-disabled');
      }

      this.swatches = null;
      this.decrementBtns = null;
      this.incrementBtns = null;
      this.atcBtn = null;
      this.inputs = null;
      this.customSwatchesLabel = null;
      this.container = null;
      this.checkbox = null;
      this.checkboxInput = null;

      // Clear bound function references
      this.boundDecrement = null;
      this.boundIncrement = null;
      this.boundToggleSelected = null;
      this.boundToggleCheckbox = null;
      this.boundAddToCart = null;

      // Reset the initialization flag
      this.isInitializing = false;
    }

    connectedCallback() {
      if (this.isInitializing) return;

      this.initialize();
    }

    disconnectedCallback() {
      this.clear();
    }

    toggleCheckbox(e) {
      e.preventDefault();

      const checkbox = this.checkbox.querySelector('.custom-purchase-option-checkbox');
      const sizes = document.querySelectorAll('variant-selects label');
      const productFormControls = document.querySelector('.ProductForm-controls');
      const originalSwatches = document.querySelector('product-swatches');

      this.checkbox.classList.toggle('background');
      checkbox.classList.toggle('custom-checkbox-check');

      if (checkbox.classList.contains('custom-checkbox-check')) {
        if (window.innerWidth >= 990) {
          this.atcBtn.style.display = 'block';
        }

        if (typeof setSizes !== 'undefined') {
          sizes.forEach((size) => {
            if (setSizes.includes(size.innerText)) {
              const container = size.closest('label');
              if (!container.classList.contains('bundle-size-available')) {
                container.classList.add('bundle-size-available');
              }
            }
          });
        }

        if (!this.allOOS) {
          const bisContainer = document.querySelector('.klaviyo-bis-container');
          if (bisContainer) {
            bisContainer.style.display = 'none';
          }
        }

        this.collapseSection(originalSwatches);

        const thisInstance = document.querySelector('custom-swatches');
        if (thisInstance) {
          this.expandSection(thisInstance);
        }

        const qtyContainer = document.querySelector('.product-form__quantity');
        const regularAtC = document.querySelector('.buy-buttons-container');
        if (qtyContainer && regularAtC) {
          qtyContainer.style.display = 'none';
          regularAtC.style.display = 'none';
          this.atcBtn.style.display = 'block';
        }
      } else {
        fetch(`${window.location.href}&section_id=${this.dataset.sectionId}`)
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            const oldGallery = document.querySelector('.product__media-wrapper');
            const newGallery = doc.querySelector('.product__media-wrapper');

            if (oldGallery && newGallery) {
              oldGallery.replaceWith(newGallery);
              const galleryContainer = document.querySelector('.ProductDetails');

              if (galleryContainer) {
                loadImageGalleries(galleryContainer);
              }
            }
          });

        document.querySelectorAll('.bundle-size-available').forEach((size) => {
          size.classList.remove('bundle-size-available');
        });

        const bisContainer = document.querySelector('.klaviyo-bis-container');
        if (bisContainer) {
          bisContainer.style.display = 'block';
        }

        this.expandSection(originalSwatches);

        const thisInstance = document.querySelector('custom-swatches');
        if (thisInstance) {
          this.collapseSection(thisInstance);
        }

        const qtyContainer = document.querySelector('.product-form__quantity');
        const regularAtC = document.querySelector('.buy-buttons-container');
        if (qtyContainer && regularAtC) {
          qtyContainer.style.display = 'block';
          regularAtC.style.display = 'block';
          this.atcBtn.style.display = 'none';
        }
      }

      const is_checked = checkbox.classList.contains('custom-checkbox-check');
      //   window.dataLayer.push({
      //     event: 'pdp_checkbox_click',
      //     is_checked: is_checked,
      //     action: 'click',
      //   });
    }

    checkAddToCartConditions() {
      if (this.totalSelected >= 4) {
        this.atcBtn.disabled = false;
        this.atcBtn.innerHTML = `<span class="btn-text">ADD TO BAG</span>`;
      } else {
        this.atcBtn.disabled = true;
        this.atcBtn.innerHTML = `<span class="btn-text">Choose 4 or more</span>`;
      }
    }

    capitalizeFirstLetter(val) {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    async addToCart() {
      const items = [];
      const validInputs = Array.from(this.inputs).filter((input) => Number(input.value) > 0);
      const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      if (!cartDrawer) return;

      this.atcBtn.setAttribute('aria-disabled', true);
      this.atcBtn.classList.add('loading');

      validInputs.forEach((input) => {
        const id = input.getAttribute('id').split('bundle-quantity-')[1];
        const quantity = input.value;

        items.push({
          id: id,
          quantity: Number(quantity),
          properties: { _test_group: 'true' },
        });
      });

      const formData = {
        items: items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(formData),
        });

        const responseData = await response.json();

        if (responseData.status) {
          console.error('Error adding to cart:', responseData.description);
          return;
        }

        // Set active element for focus management
        cartDrawer.setActiveElement(document.activeElement);

        // Remove empty state class before rendering contents
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner && drawerInner.classList.contains('is-empty')) {
          drawerInner.classList.remove('is-empty');
        }
        cartDrawer.classList.remove('is-empty');

        // Render the cart contents
        cartDrawer.renderContents(responseData);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.atcBtn.classList.remove('loading');
        this.atcBtn.removeAttribute('aria-disabled');
      }
    }

    toggleSelected(e) {
      const container = e.target.closest('.bundle-swatch');
      const selected = this.querySelector('.bundle-swatch.selected');

      const inputContainer = container.nextElementSibling;
      const input = inputContainer.querySelector('input');
      const max = parseInt(input.getAttribute('max'));

      const selectedQuantity = container.closest('.bundle-swatch-container').querySelector('.bundle-selected-quantity');

      const urlToFetch = window.location.href.split('/products')[0];

      fetch(
        `${urlToFetch}/${container.dataset.fetchLink}?variant=${container.dataset.variantId}&section_id=${this.dataset.sectionId}`,
      )
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');

          const oldGallery = document.querySelector('.product__media-wrapper');
          const newGallery = doc.querySelector('.product__media-wrapper');

          if (oldGallery && newGallery) {
            oldGallery.replaceWith(newGallery);
            const galleryContainer = document.querySelector('.ProductDetails');

            if (galleryContainer) {
              loadImageGalleries(galleryContainer);
            }
          }
        });

      if (input.value == 0 && input.value < max) {
        const value = parseInt(input.value);
        input.value = value + 1;
        this.totalSelected++;

        this.checkAddToCartConditions();

        selectedQuantity.textContent = input.value;
        if (!selectedQuantity.classList.contains('has-quantity')) {
          selectedQuantity.classList.add('has-quantity');
        }

        const colorValue = container.dataset.colorName;

        if (!this.colorsSelected.includes(this.capitalizeFirstLetter(colorValue))) {
          this.colorsSelected.push(this.capitalizeFirstLetter(colorValue));
        }
        this.adjustLabel();
      }

      if (selected) {
        selected.classList.remove('selected');
      }

      container.classList.add('selected');

      const parentModel = container.dataset.parentModel;

      //   window.dataLayer.push({
      //     event: 'pdp_checkbox_swatch_click',
      //     parent_model: parentModel,
      //     color: container.dataset.colorName,
      //     action: 'click',
      //   });
    }

    increment(e) {
      e.preventDefault();
      const selectedQuantity = e.target.closest('.bundle-swatch-container').querySelector('.bundle-selected-quantity');
      const input = e.target.parentElement.querySelector('input');
      const max = parseInt(input.getAttribute('max'));
      const value = parseInt(input.value);
      if (value < max) {
        input.value = value + 1;
        this.totalSelected++;

        this.checkAddToCartConditions();
      }

      selectedQuantity.textContent = input.value;
      if (!selectedQuantity.classList.contains('has-quantity')) {
        selectedQuantity.classList.add('has-quantity');
      }

      const addedColor = e.target.closest('.bundle-swatch-container').querySelector('.bundle-swatch');
      const colorValue = addedColor.dataset.colorName;

      if (!this.colorsSelected.includes(this.capitalizeFirstLetter(colorValue))) {
        this.colorsSelected.push(this.capitalizeFirstLetter(colorValue));
      }
      this.adjustLabel();
    }

    decrement(e) {
      e.preventDefault();
      const selectedQuantity = e.target.closest('.bundle-swatch-container').querySelector('.bundle-selected-quantity');
      const input = e.target.parentElement.querySelector('input');
      const value = parseInt(input.value);
      if (value > 0) {
        input.value = value - 1;
        this.totalSelected--;

        this.checkAddToCartConditions();
      }

      if (input.value > 0) {
        selectedQuantity.textContent = input.value;
        selectedQuantity.classList.add('has-quantity');
      } else {
        selectedQuantity.textContent = '';
        selectedQuantity.classList.remove('has-quantity');
      }

      const removedColor = e.target.closest('.bundle-swatch-container').querySelector('.bundle-swatch');
      const colorValue = removedColor.dataset.colorName;

      if (this.colorsSelected.includes(this.capitalizeFirstLetter(colorValue)) && input.value == 0) {
        const index = this.colorsSelected.indexOf(this.capitalizeFirstLetter(colorValue));
        this.colorsSelected.splice(index, 1);
      }
      this.adjustLabel();
    }

    adjustLabel() {
      if (this.colorsSelected.length == 0) {
        this.customSwatchesLabel.innerHTML = 'Color';
      } else {
        this.customSwatchesLabel.innerHTML = `Colors: <span class="selected-colors">${this.colorsSelected.join(
          ', ',
        )}</span>`;
      }
    }

    collapseSection(element) {
      const sectionHeight = element.scrollHeight;
      const elementTransition = element.style.transition;

      element.style.transition = '';

      requestAnimationFrame(function () {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        requestAnimationFrame(function () {
          element.style.height = 0 + 'px';
        });
      });

      element.setAttribute('data-collapsed', 'true');
    }

    expandSection(element) {
      const sectionHeight = element.scrollHeight;

      const handleTransitionEnd = (e) => {
        element.style.height = 'auto';
        element.removeEventListener('transitionend', handleTransitionEnd);
      };

      element.style.height = sectionHeight + 'px';
      element.addEventListener('transitionend', handleTransitionEnd);
      element.setAttribute('data-collapsed', 'false');
    }
  }

  customElements.define('custom-swatches', CustomSwatches);
}
